import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import translationES from './translations/i18n/es/locale.json';
import translationEN from './translations/i18n/en/locale.json';

const resources = {
  en: { translations: translationEN },
  es: { translation: translationES }
};
const debug = process.env.NODE_ENV === 'dev' ? true : false;
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: debug,
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      wait: true,
      bindI18n: 'languageChanged loaded'
    }
  });

export default i18n;
